import axios from 'axios';

// Create an Axios instance with default configuration
const axiosInstance = axios.create({
  baseURL: 'http://localhost:3333/api/v1',  // Replace with your API's base URL
//   timeout: 10000, // Optional: Set a timeout for requests (in milliseconds)
  headers: {
    'Content-Type': 'application/json',
    // Add other headers, like Authorization if needed
    // 'Authorization': 'Bearer yourToken',
  },
});



export default axiosInstance;
